
<template>
  <transition
    name="fade"
    @beforeEnter="beforeEnter"
    @enter="enter"
    @leave="leave"
  >
    <div v-if="this.scenes.scene">
      <!-- buttons start -->
      <!-- <button @click="startRunning">play</button>
      <button @click="playSegments">play segment</button>
      <button @click="stopRunning">Stop</button>
      <button @click="NextScene">test</button>

      <button @click="MoveToAnchor('.character-wrap', '.anchor#a1')">
        anim_to_p1
      </button>
      <button @click="MoveToAnchor('.character-wrap', '.anchor#a2')">
        anim_to_p2
      </button>
      <button
        @click="MoveToAnchor('.character-wrap', ['.anchor#a2', '.anchor#a1'])"
      >
        anim_p2_to_p1
      </button> -->
      <!-- buttons end -->
      <div>
        <!-- scene0 -->
        <div class="scene-wrap" v-if="this.sceneDisplay[0]">
          <kinesis-container class="scene">
            <!-- background start -->
            <kinesis-element
              active="false"
              :strength="0"
              type="translate"
              axis="x"
            >
              <div class="scene-bg-wrap">
                <img class="scene-bg" src="/images/scene1/8_bg.png" />
              </div>
            </kinesis-element>
            <kinesis-element :strength="-10" type="translate" axis="x">
              <div class="scene-bg-wrap">
                <img class="scene-bg" src="/images/scene1/7_back.png" />
              </div>
            </kinesis-element>
            <kinesis-element :strength="-8" type="translate" axis="x">
              <div class="scene-bg-wrap">
                <img class="scene-bg" src="/images/scene1/6_back_islands.png" />
              </div>
            </kinesis-element>
            <kinesis-element :strength="-6" type="translate" axis="x">
              <div class="scene-bg-wrap">
                <img class="scene-bg" src="/images/scene1/5_front_island.png" />
              </div>
            </kinesis-element>
            <kinesis-element :strength="-4" type="translate" axis="x">
              <div class="scene-bg-wrap">
                <img
                  class="scene-bg bg-backwave"
                  src="/images/scene1/4_back_wave.png"
                />
              </div>
            </kinesis-element>
            <kinesis-element :strength="-2" type="translate" axis="x">
              <div class="scene-bg-wrap">
                <img
                  class="scene-bg bg-frontwave"
                  src="/images/scene1/3_front_wave.png"
                />
              </div>
            </kinesis-element>
            <!-- background-end -->
            <!-- midground start -->
            <kinesis-element :strength="0" type="translate" axis="x" maxY="0">
              <!-- stage start -->
              <!-- <Task :currentScene="this.currentScene" /> -->
              <!-- stage end -->
            </kinesis-element>
            <Task :currentScene="this.currentScene" />
            <!-- midground end -->
            <!-- foreground start -->
            <kinesis-element :strength="5" type="translate" axis="x">
              <div class="scene-bg-wrap">
                <img
                  class="scene-bg scene-foreground"
                  src="/images/scene1/2_middle_grass.png"
                />
              </div>
            </kinesis-element>
            <kinesis-element :strength="10" type="translate" axis="x">
              <div class="scene-bg-wrap">
                <img
                  class="scene-bg scene-foreground"
                  src="/images/scene1/1_front_grass.png"
                />
              </div>
            </kinesis-element>
            <!-- foreground end -->
          </kinesis-container>
        </div>
        <!-- scene 1 2a - Old City -->
        <div class="scene-wrap" v-if="this.sceneDisplay[1]">
          <!-- <Task :currentScene="this.currentScene" /> -->
          <kinesis-container class="scene">
            <!-- background start -->
            <kinesis-element :strength="0" type="translate" axis="x">
              <div class="scene-bg-wrap">
                <img class="scene-bg" src="/images/scene2a/7_bg.png" />
              </div>
            </kinesis-element>
            <kinesis-element :strength="-14" type="translate" axis="x">
              <div class="scene-bg-wrap">
                <img class="scene-bg" src="/images/scene2a/6_sky.png" />
              </div>
            </kinesis-element>
            <kinesis-element :strength="-12" type="translate" axis="x">
              <div class="scene-bg-wrap">
                <img
                  class="scene-bg"
                  src="/images/scene2a/5_backtree_balloon.png"
                />
              </div>
            </kinesis-element>
            <kinesis-element :strength="0" type="translate" axis="x">
              <div class="scene-bg-wrap">
                <img class="scene-bg" src="/images/scene2a/4_tree_wall.png" />
              </div>
            </kinesis-element>
            <kinesis-element :strength="0" type="translate" axis="x">
              <div class="scene-bg-wrap">
                <img
                  class="scene-bg"
                  src="/images/scene2a/2_grass_texture.png"
                />
              </div>
            </kinesis-element>
            <!-- background-end -->
            <!-- midground start -->
            <kinesis-element :strength="0" type="translate" axis="x">
              <!-- stage start -->
              <!-- <Task :currentScene="this.currentScene" /> -->
              <!-- stage end -->
            </kinesis-element>
            <Task :currentScene="this.currentScene" />

            <!-- midground end -->
            <!-- foreground start -->
            <kinesis-element :strength="8" type="translate" axis="x">
              <div class="scene-bg-wrap">
                <img
                  class="scene-bg scene-foreground"
                  src="/images/scene2a/1_front.png"
                />
              </div>
            </kinesis-element>
            <!-- foreground end -->
          </kinesis-container>
        </div>
        <!-- scene 2 2b - Future City -->
        <div class="scene-wrap" v-if="this.sceneDisplay[2]">
          <kinesis-container class="scene">
            <!-- background start -->
            <kinesis-element :strength="-16" type="translate" axis="x">
              <div class="scene-bg-wrap">
                <img class="scene-bg" src="/images/scene2b/6.png" />
              </div>
            </kinesis-element>
            <kinesis-element :strength="-13" type="translate" axis="x">
              <div class="scene-bg-wrap">
                <img class="scene-bg" src="/images/scene2b/5.png" />
              </div>
            </kinesis-element>
            <kinesis-element :strength="-10" type="translate" axis="x">
              <div class="scene-bg-wrap">
                <img class="scene-bg" src="/images/scene2b/4.png" />
              </div>
            </kinesis-element>
            <kinesis-element :strength="-6" type="translate" axis="x">
              <div class="scene-bg-wrap">
                <img class="scene-bg" src="/images/scene2b/3.png" />
              </div>
            </kinesis-element>
            <kinesis-element :strength="-6" type="translate" axis="x">
              <div class="scene-bg-wrap">
                <img class="scene-bg" src="/images/scene2b/2.png" />
              </div>
            </kinesis-element>
            <kinesis-element :strength="0" type="translate" axis="x">
              <div class="scene-bg-wrap">
                <img class="scene-bg" src="/images/scene2b/1.png" />
              </div>
              <div class="scene-bg-wrap">
                <img
                  class="scene-bg flashAnim"
                  src="/images/scene2b/screen.png"
                />
              </div>
            </kinesis-element>
            <!-- background-end -->
            <!-- midground start -->
            <kinesis-element :strength="0" type="translate" axis="x">
              <!-- stage start -->
              <div class="scene-bg-wrap">
                <img class="scene-bg" src="/images/scene2b/lift.png" />
              </div>
              <div class="scene-bg-wrap">
                <img
                  class="scene-bg s2-lift"
                  src="/images/scene2b/lift-inside.png"
                />
              </div>

              <!-- <Task :currentScene="this.currentScene" /> -->

              <!-- stage end -->
            </kinesis-element>
            <Task :currentScene="this.currentScene" />

            <div class="scene-bg-wrap s2-card-cover">
              <img class="scene-bg" src="/images/scene2b/card_cover-01.png" />
            </div>

            <div class="scene-bg-wrap">
              <img
                class="scene-bg scene-foreground s2-light"
                src="/images/scene2b/light-01.png"
              />
            </div>

            <!-- midground end -->

            <!-- foreground end -->
          </kinesis-container>
        </div>
        <!-- scene 3 3a - Light House -->
        <div class="scene-wrap" v-if="this.sceneDisplay[3]">
          <!-- <Task :currentScene="this.currentScene" /> -->
          <kinesis-container class="scene">
            <!-- background start -->

            <kinesis-element :strength="0" type="translate" axis="x">
              <div class="scene-bg-wrap">
                <img class="scene-bg" src="/images/scene3a/7_bg.png" />
              </div>
            </kinesis-element>
            <kinesis-element :strength="-4" type="translate" axis="x">
              <div class="scene-bg-wrap">
                <img class="scene-bg" src="/images/scene3a/6_top.png" />
              </div>
            </kinesis-element>
            <kinesis-element :strength="0" type="translate" axis="x">
              <div class="scene-bg-wrap">
                <img class="scene-bg" src="/images/scene3a/5_upperfloor.png" />
              </div>
            </kinesis-element>
            <kinesis-element :strength="-2" type="translate" axis="x">
              <div class="scene-bg-wrap">
                <img class="scene-bg" src="/images/scene3a/4_floor.png" />
              </div>
            </kinesis-element>
            <kinesis-element :strength="0" type="translate" axis="x">
              <div class="scene-bg-wrap">
                <img class="scene-bg" src="/images/scene3a/3_cabinet.png" />
              </div>
            </kinesis-element>
            <!-- background-end -->
            <!-- midground start -->
            <kinesis-element :strength="0" type="translate" axis="x">
              <!-- <div class="scene-bg-wrap">
                <img class="scene-bg" src="/images/scene3a/2_npc.png" />
              </div> -->
              <!-- stage start -->
              <!-- <Task :currentScene="this.currentScene" /> -->
              <!-- stage end -->
            </kinesis-element>
            <Task :currentScene="this.currentScene" />

            <!-- midground end -->
            <!-- foreground start -->
            <kinesis-element :strength="4" type="translate" axis="x">
              <div class="scene-bg-wrap">
                <img
                  class="scene-bg scene-foreground"
                  src="/images/scene3a/1_front.png"
                />
              </div>
            </kinesis-element>
            <!-- foreground end -->
          </kinesis-container>
        </div>
        <!-- scene 4 3b - Circus -->
        <div class="scene-wrap" v-if="this.sceneDisplay[4]">
          <kinesis-container class="scene">
            <!-- background start -->
            <kinesis-element :strength="-8" type="translate" axis="x">
              <div class="scene-bg-wrap">
                <img class="scene-bg" src="/images/scene3b/6.png" />
              </div>
            </kinesis-element>
            <kinesis-element :strength="-4" type="translate" axis="x">
              <div class="scene-bg-wrap">
                <img class="scene-bg" src="/images/scene3b/5.png" />
              </div>
            </kinesis-element>
            <kinesis-element :strength="0" type="translate" axis="x">
              <!-- <div class="scene-bg-wrap">
                    <div class="scene-bg-color" scene-id="1"></div>
                  </div> -->
              <div class="scene-bg-wrap">
                <img class="scene-bg" src="/images/scene3b/4.png" />
              </div>
            </kinesis-element>
            <kinesis-element :strength="0" type="translate" axis="x">
              <div class="scene-bg-wrap">
                <img class="scene-bg" src="/images/scene3b/3.png" />
              </div>
            </kinesis-element>
            <kinesis-element :strength="-4" type="translate" axis="x">
              <div class="scene-bg-wrap">
                <img class="scene-bg s4-light" src="/images/scene3b/48.png" />
              </div>
            </kinesis-element>
            <!-- background-end -->
            <!-- midground start -->
            <kinesis-element :strength="0" type="translate" axis="x">
              <!-- stage start -->
              <div class="scene-bg-wrap">
                <img class="scene-bg" src="/images/scene3b/bucket-back.png" />
              </div>

              <!-- stage end -->
            </kinesis-element>
            <Task :currentScene="this.currentScene" />

            <kinesis-element :strength="0" type="translate" axis="x">
              <!-- stage start -->
              <div class="scene-bg-wrap">
                <img class="scene-bg" src="/images/scene3b/bucket-front.png" />
              </div>

              <!-- stage end -->
            </kinesis-element>
            <!-- midground end -->
            <!-- foreground start -->
            <kinesis-element :strength="-4" type="translate" axis="x">
              <div class="scene-bg-wrap">
                <img
                  class="scene-bg scene-foreground s4-light"
                  src="/images/scene3b/47.png"
                />
              </div>
            </kinesis-element>

            <kinesis-element :strength="2" type="translate" axis="x">
              <div class="scene-bg-wrap">
                <img
                  class="scene-bg scene-foreground"
                  src="/images/scene3b/0.png"
                />
              </div>
            </kinesis-element>
            <!-- foreground end -->
          </kinesis-container>
        </div>
        <!-- hint start -->
        <div
          class="scene-wrap overflow"
          v-if="this.hint[lang][this.currentScene]"
        >
          <div class="hints-wrap hide">
            <img class="" src="/images/ui/hint-top.png" />
            <div class="hints-inner">
              <div class="hints-content">
                <div class="header">
                  {{ this.hint[lang][this.currentScene]["name"] }}
                </div>
                <div>
                  {{ this.hint[lang][this.currentScene]["hint"] }}
                </div>
                <div class="tips">
                  {{ this.hint[lang][this.currentScene]["tips"] }}
                </div>
              </div>
            </div>
            <img class="" src="/images/ui/hint-bottom.png" />
          </div>
        </div>
        <!-- hint end -->
        <!-- exit start -->
        <div class="scene-wrap overflow">
          <div class="exit-wrap">
            <div
              v-for="(exit, key) in tasks[this.currentScene]['exit']"
              :key="key"
              class="exit-item"
              @click="NextScene"
              :exit-id="exit['id']"
              :style="`top:${exit['top']}; 
        left:${exit['left']};
         width:${exit['width']}; 
        height:${exit['height']};`"
            >
              <div class="exit-arrow">
                <img
                  :class="exit['class']"
                  src="images/exit_arrow.gif"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
        <!-- exit end -->
      </div>
    </div>
  </transition>
</template>

<script>
import $ from "jquery";
// import anime from "animejs";
// import LottieAnimation from "lottie-vuejs/src/LottieAnimation.vue";

import { KinesisContainer, KinesisElement } from "vue-kinesis";
// import LottieAnimation from "lottie-vuejs/src/LottieAnimation.vue";
import gameController from "./../gameController";
// import * as gameVariable from "../gameController";
import Task from "./Task.vue";
import taskData from "./../assets/data/task.json";
import hintData from "./../assets/data/hint.json";

export default {
  name: "Scene",
  components: {
    KinesisContainer,
    KinesisElement,
    // LottieAnimation,
    Task,
    // Loading,
  },
  props: ["scenes", "sceneDisplay", "level", "currentScene", "lang"],
  data() {
    return {
      runner: "",
      hint: hintData,
      tasks: taskData,
    };
  },
  created() {
    // console.log($("lottie-animation"));
    // $("lottie-animation").stop();
    // this.emitter.emit("toggle-sidebar", "test");
    this.emitter.on("show-exit", (scene) => {
      console.log("exit received scene: " + scene);
      if (scene == this.currentScene) {
        if (this.currentScene < 3) {
          $(".exit-wrap").addClass("block");
          setTimeout(
            function () {
              $(".exit-wrap").addClass("show");
            }.bind(this),
            500
          );
        } else {
          //if level2 to ending
          // this.emitter.emit("hide-scene");
        }
      }

      // console.log("[app] show exit");
    });
  },
  mounted() {},

  methods: {
    beforeEnter() {},
    enter(done) {
      var eventLabel = gameController.ConvertScene(this.currentScene);
      console.log("current scene: " + this.currentScene);
      console.log("[Event] label: " + eventLabel);
      this.$gtag.event("enter", {
        event_category: "stage",
        event_label: eventLabel,
        event_value: eventLabel
      });

      var event="stage: " + eventLabel;
      this.$gtag.event(event, {
        event_category: "stage",
        event_label: eventLabel,
      });

      console.log("[scene] enter");
      // console.log("current scene:" + gameVariable.currentScene);
      // this.$nextTick(function () {
      //   // Code that will run only after the
      //   // entire view has been rendered
      //   console.log("[Scene] loaded");

      //   this.emitter.emit("finish-loading");
      // });
      this.emitter.on("hide-loading", () => {
        if (this.scenes.scene && $(".hints-wrap")) {
          $(".hints-wrap").removeClass("hide");
        }
        // console.log("[loading] show scene");
      });

      done;
    },
    leave(done) {
      console.log("[scene] leave");

      //if not last scene, go to next scene
      var level = this.level;
      console.log("scene level: " + level);

      if (level < 3) {
        this.emitter.emit("show-scene");
      } else if (level == 3) {
        //to ending
        // this.emitter.emit("show-ending");
      }
      done;
    },

    MoveToAnchor(target, anchor) {
      gameController.AnimeToAnchor(target, anchor);
    },
    NextScene(event) {
      // console.log(event)
      var exitId = $(event.currentTarget).attr("exit-id");
      // gameController.UpdateSceneData(exitId);
      console.log("[task] exit id: " + exitId);
      this.emitter.emit("next-scene", exitId);
      this.emitter.emit("hide-scene");
      console.log("[task] next scene");
    },
  },
};
</script>


